const PaddingSection = () => {

    return (
        <section className="padding-only" />
    )

}

export default PaddingSection